function view (path) {
  return () => import(/* webpackChunkName: 'lo-v1' */ '@/views/lo/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const RLogisticsOfficer = [
  {
    path: '/logistics-officer/dashboard',
    component: view('Dashboard'),
    name: 'lo.dashboard',
    authorizedRole: 'lo'
  }
]

const RLOPurchaseOrderDeliveries = [
  {
    path: '/logistics-officer/purchase-orders/deliveries/scheduling/:scheduler?',
    component: view('scheduling/Base'),
    name: 'lo.deliveries.scheduling',
    authorizedRole: 'lo',
    meta: {
      breadcrumb: [
        {
          text: 'Logistics Officer'
        },
        {
          text: 'Deliveries'
        },
        {
          text: 'Scheduling',
          active: true
        }
      ]
    }
  },
  {
    path: '/logistics-officer/purchase-orders/deliveries/dispatching/:dispatcher?',
    component: view('dispatching/Base'),
    name: 'lo.deliveries.dispatching',
    authorizedRole: 'lo',
    meta: {
      breadcrumb: [
        {
          text: 'Logistics Officer'
        },
        {
          text: 'Deliveries'
        },
        {
          text: 'Dispatching',
          active: true
        }
      ]
    }
  },
  {
    path: '/logistics-officer/purchase-orders/deliveries/receiving/:receiver?',
    component: view('receiving/Base'),
    name: 'lo.deliveries.receiving',
    authorizedRole: 'lo',
    meta: {
      breadcrumb: [
        {
          text: 'Logistics Officer'
        },
        {
          text: 'Deliveries'
        },
        {
          text: 'Receiving',
          active: true
        }
      ]
    }
  },
  {
    path: '/logistics-officer/purchase-orders/deliveries/closing/:closer?',
    component: view('closing/Base'),
    name: 'lo.deliveries.closing',
    authorizedRole: 'lo',
    meta: {
      breadcrumb: [
        {
          text: 'Logistics Officer'
        },
        {
          text: 'Closing',
          active: true
        }
      ]
    }
  }
]

const RLOAtws = [
  {
    path: '/logistics-officer/atws/withdrawals/:withdrawer?/:status?',
    component: view('atws/withdrawals/Base'),
    name: 'lo.atws.withdrawals',
    authorizedRole: 'lo',
    meta: {
      breadcrumb: [
        {
          text: 'Logistics Officer'
        },
        {
          text: 'ATWs'
        },
        {
          text: 'Transfers',
          active: true
        }
      ]
    }
  },
  {
    path: '/logistics-officer/atws/printing/:printer?',
    component: view('atws/printing/Base'),
    name: 'lo.atws.printing',
    authorizedRole: 'lo',
    meta: {
      breadcrumb: [
        {
          text: 'Logistics Officer'
        },
        {
          text: 'ATWs'
        },
        {
          text: 'Printing',
          active: true
        }
      ]
    }
  }
]

const RLOMaintenances = [
  {
    path: '/logistics-officer/maintenances/vehicles',
    component: view('maintenances/Vehicles'),
    name: 'lo.maintenances.vehicles',
    authorizedRole: 'lo',
    meta: {
      breadcrumb: [
        {
          text: 'Logistics Officer'
        },
        {
          text: 'Maintenances'
        },
        {
          text: 'Vehicles',
          active: true
        }
      ]
    }
  },
  {
    path: '/logistics-officer/maintenances/drivers',
    component: view('maintenances/Drivers'),
    name: 'lo.maintenances.drivers',
    authorizedRole: 'lo',
    meta: {
      breadcrumb: [
        {
          text: 'Logistics Officer'
        },
        {
          text: 'Maintenances'
        },
        {
          text: 'Drivers',
          active: true
        }
      ]
    }
  }
]

export default RLogisticsOfficer.concat(
  RLOPurchaseOrderDeliveries,
  RLOAtws,
  RLOMaintenances
)
